import { request } from '@/api';

/**
 * 消息查询对象
 */
export interface MessageQuery {
  /**
   * 通知类型: 1-开户消息, 2-资金消息, 3-告警消息
   */
  notifyType?: string;
  /**
   * 状态: 0=未读, 1=已读
   */
  state?: string;
}

/**
 * 消息记录
 */
export interface MessageRecord {
  createOrg: string | null;
  createBy: string | null;
  createTimes: string | null;
  updateBy: string | null;
  updateTimes: string | null;
  isDeleted: number;
  deleteTimes: string | null;
  messageId: string;
  businessId: string;
  notifyType: number;
  userId: string;
  title: string;
  body: string;
  state: number; // 0=未读, 1=已读
}

/**
 * 分页查询参数
 */
export interface MessagePageParams {
  pageSize: number;
  pageNum: number;
  object: MessageQuery;
}

/**
 * 分页响应数据
 */
export interface MessagePageResult {
  records: MessageRecord[];
  total: number;
  size: number;
  current: number;
  pages: number;
}

/**
 * 获取消息列表
 */
export const getMessageList = (params: MessagePageParams) => {
  return request.post<MessagePageResult>('/business/message/list', params);
};

/**
 * 标记消息为已读
 */
export const markMessageRead = (messageId: string) => {
  return request.post('/business/message/readAlready', null, { params: { messageId } });
};

/**
 * 批量标记消息为已读
 */
export const markMessageReadByIds = (messageIds: Array<string | number>) => {
  return request.post('/business/message/readAlreadyByIds', { messageIds: messageIds });
};